const FeatureFlagConstants = {
  ZRM_MARKETING_COMPONENTS_ENABLED: 'ZRM_MARKETING_COMPONENTS_ENABLED',
} as const;

export default FeatureFlagConstants;
